module.exports = __webpack_public_path__ + "static/img/kjdy2.0b1b6ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy2.png
// module id = 335
// module chunks = 0